import {
  Constructor,
  GraphComponent,
  ILabel,
  IRenderContext,
  LabelStyleBase,
  Size,
  SvgVisual,
} from '@ardoq/yfiles';
import { LabelExportSupport } from '@ardoq/graph';
import { URL_ICON_SIZE } from './consts';
import { renderUrlLabel } from './renderUrlLabel';

/**
 * Export support for URL labels - excludes them from JSON export
 * since they are purely visual indicators and not semantic labels
 */
const ardoqURLLabelExportSupport = {
  toJSON: (_gc: GraphComponent, _label: ILabel) => [],
} satisfies LabelExportSupport;

export class ArdoqURLLabelStyle extends LabelStyleBase {
  static Instance = new ArdoqURLLabelStyle();
  private constructor() {
    super();
  }

  protected override lookup(label: ILabel, type: Constructor): unknown {
    if (type === LabelExportSupport) {
      return ardoqURLLabelExportSupport;
    }
    return super.lookup(label, type);
  }

  override createVisual(context: IRenderContext, label: ILabel) {
    const g = renderUrlLabel(label);
    const transform = LabelStyleBase.createLayoutTransform(
      context,
      label.layout,
      true
    );
    transform.applyTo(g);
    return new SvgVisual(g);
  }

  override getPreferredSize() {
    return new Size(URL_ICON_SIZE, URL_ICON_SIZE);
  }
}
